export interface PaymentSummary {
  month?: string;
  quarter?: number;
  year?: number;
  noProperties: number;
  noProducts: number;
  noLineItems: number;
  grossAmount: number;
  netAmount: number;
  severance: number;
  deductions: number;
  data: PaymentSummaryData[];
}

/** Neutral value stored when a payment summary request fails or returns nothing. */
export const EMPTY_PAYMENT_SUMMARY: PaymentSummary = {
  noProperties: 0,
  noProducts: 0,
  noLineItems: 0,
  grossAmount: 0,
  netAmount: 0,
  severance: 0,
  deductions: 0,
  data: []
};

export interface PaymentSummaryData {
  name: string;
  value: number;
}

export interface PaymentSummaryByPropertyOrProduct {
  name: string;
  value: number;
}

export interface Product {
  name: string;
  series: Series[];
}

export interface Series {
  name: string;
  value: number;
}

export interface PaymentSummaryByItem {
  month?: string;
  year?: number;
  quarter?: number;
  products?: ItemData[];
  properties?: ItemData[];
  data: PaymentSummaryData[];
}

export interface ItemData {
  property?: Property;
  product?: Product;
  noProducts: number;
  noLineItems: number;
  grossAmount: number;
  netAmount: number;
  severance: number;
  deductions: number;
}

export interface Property {
  name: string;
  id: number;
}

export interface PaymentSummaryByPeriodSeriesData {
  name: string;
  series: Series[];
}

export interface PaymentSummaryOld {
  paymentDate: string;
  salesYear: number;
  salesMonth: number;

  operatorId: number;
  operatorName: string;

  checkNo: number;
  properties: string;

  paymentCount: number;
  propertyCount: number;
  paymentTotal: number;
}

export interface PaymentCount {
  paymentCount: number;
}
